import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, CalendarCheck, Phone, Eye, Microscope } from "lucide-react";
import { CONTACT, IMG, DOCTORS } from "@/data/site";

const DeptChip = ({ to, icon: Icon, color, hi, en, doc, tid }) => (
  <Link to={to} data-testid={tid} className="group flex items-center gap-3 rounded-2xl border border-white/15 bg-white/10 p-3 pr-4 backdrop-blur-md transition-colors hover:bg-white/20">
    <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${color} text-white`}><Icon className="h-5 w-5" /></span>
    <span className="min-w-0 flex-1">
      <span className="block font-semibold text-white">{hi}</span>
      <span className="font-en block truncate text-xs text-white/65">{en} · {doc}</span>
    </span>
    <ArrowUpRight className="h-4 w-4 text-white/70 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
  </Link>
);

const Collage = () => (
  <div className="relative hidden h-[540px] lg:block">
    <motion.div initial={{ opacity: 0, x: 40 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: .9, delay: .2 }}
      className="absolute right-0 top-0 h-[300px] w-[78%] overflow-hidden rounded-[28px] border-4 border-white/10 shadow-2xl">
      <img src={IMG.inauguration} alt="Eye care" className="h-full w-full object-cover object-[center_35%]" />
      <span className="absolute bottom-4 left-4 rounded-full bg-maroon px-3 py-1 text-xs font-semibold text-white">नेत्र रोग विभाग</span>
    </motion.div>
    <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .9, delay: .35 }}
      className="absolute bottom-0 left-0 h-[280px] w-[62%] overflow-hidden rounded-[28px] border-4 border-white/10 shadow-2xl">
      <img src={IMG.surgeryOT} alt="Surgery" className="h-full w-full object-cover" />
      <span className="absolute bottom-4 left-4 rounded-full bg-surg px-3 py-1 text-xs font-semibold text-white">सर्जरी विभाग</span>
    </motion.div>
    <motion.div initial={{ opacity: 0, scale: .9 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: .8, delay: .5 }}
      className="absolute bottom-10 right-2 w-[44%] rounded-3xl bg-white p-5 shadow-2xl">
      <p className="eyebrow text-maroon">2 विशेषज्ञ डॉक्टर</p>
      <div className="mt-3 space-y-3">
        {DOCTORS.map((d) => (
          <div key={d.key} className="flex items-center gap-3">
            <img src={d.photo} alt={d.nameEn} className="h-11 w-11 rounded-full object-cover object-top" />
            <div className="min-w-0"><p className="truncate font-semibold text-ink">{d.nameHi}</p><p className="font-en truncate text-xs text-muted2">{d.specialtyEn}</p></div>
          </div>
        ))}
      </div>
    </motion.div>
  </div>
);

export const MainSlide = () => (
    <div className="container-x relative grid items-center gap-10 py-16 md:py-20 lg:grid-cols-12 lg:py-24">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .8 }} className="lg:col-span-6">
        <p className="eyebrow text-amber-300">Medicity Hospital · Ballia</p>
        <h1 className="font-display mt-5 text-4xl leading-[1.15] text-white sm:text-5xl lg:text-6xl">
          आँखों की रोशनी से <br className="hidden sm:block" />
          <span className="text-amber-300">दूरबीन सर्जरी</span> तक —<br className="hidden sm:block" /> एक भरोसेमंद अस्पताल
        </h1>
        <p className="font-en mt-5 max-w-xl text-base text-white/75 md:text-lg">World-class eye care and general & laparoscopic surgery under one roof — explained simply, at honest cost.</p>
        <div className="mt-8 grid gap-3 sm:grid-cols-2">
          <DeptChip to="/eye-care" tid="hero-dept-eye" icon={Eye} color="bg-maroon" hi="नेत्र सेवाएँ" en="Eye Care" doc="Dr. Rakhshanda" />
          <DeptChip to="/surgery" tid="hero-dept-surgery" icon={Microscope} color="bg-surg" hi="सर्जरी" en="Laparoscopic Surgery" doc="Dr. Danish" />
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/#appointment" data-testid="hero-book-appointment-button" className="btn btn-light"><CalendarCheck className="h-4 w-4" /> अपॉइंटमेंट बुक करें</Link>
          <a href={`tel:${CONTACT.phoneDial}`} data-testid="hero-call-button" className="btn btn-outline text-white"><Phone className="h-4 w-4" /> {CONTACT.phoneDisplay}</a>
        </div>
      </motion.div>
      <div className="lg:col-span-6"><Collage /></div>
    </div>
);
